import { paymentPath, paymentLabel, money } from '../../utils/directPayment';
import React, { useEffect, useState } from "react";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { Link, redirect, useNavigate } from "react-router-dom";
import { get_dashboard_index_data } from "../../store/reducers/dashboardReducer";
import { Package, PackageMinus, PackageOpen, PackagePlus } from "lucide-react";
import { Button } from "../ui/button";
import { formatCurrency, fetchExchangeRates } from "../../utils/currencyUtils";
import api from "../../api/api";

const Index = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { totalOrder, pendingOrder, recentOrders, cancelledOrder } =
    useSelector((state) => state.dashboard);

  const dispatch = useDispatch();
  const [exchangeRates, setExchangeRates] = useState({});
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (userInfo && userInfo.id) {
        try {
          const { data } = await api.get("/account/get-details");
          if (data.currency) {
            setCurrencyCode(data.currency);
          }
        } catch (error) {
          console.error("Error fetching user currency:", error);
        }
      }
    };
    fetchUserDetails();
  }, [userInfo]);

  useEffect(() => {
    dispatch(get_dashboard_index_data(userInfo.id));
    fetchExchangeRates().then((rates) => {
      setExchangeRates(rates);
      setExchangeLoaded(true);
    });
  }, []);

  const redirect = (ord) => {
    let items = 0;
    for (let i = 0; i < ord.products.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate(paymentPath(ord), {
      state: {
        price: ord.price + (ord.shipping_fee || 0),
        items,
        orderId: ord._id,
        customerName: ord.shippingInfo.name,
        customerPhone: ord.shippingInfo.phone

      },
    });
  };
  return (
    <div>
      <div className="grid grid-cols-3 md:grid-cols-1 gap-4 sm:gap-2 mb-4 sm:px-4 sm:mb-2">
        <div className="flex tems-center p-5 bg-[#070707]  rounded-md gap-5">
          <div className="w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl">
              <PackagePlus size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-white">
            <h2 className="text-3xl font-bold sm:mr-2">{totalOrder}</h2>
            <span>Orders</span>
          </div>
        </div>
        <div className="flex  items-center p-5  bg-[#070707]  rounded-md gap-5">
          <div className=" w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl ">
              <Package size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-white">
            <h2 className="text-3xl font-bold sm:mr-2">{pendingOrder}</h2>
            <span>Pending Orders</span>
          </div>
        </div>
        <div className="flex  items-center p-5 bg-[#070707]  rounded-md gap-5">
          <div className="w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl ">
            <span className="text-xl">
              <PackageMinus size={32} />
            </span>
          </div>
          <div className="flex flex-col justify-start items-start sm:flex-row sm:items-center text-white">
            <h2 className="text-3xl font-bold sm:mr-2">{cancelledOrder}</h2>
            <span>Cancelled Orders</span>
          </div>
        </div>
      </div>
      <div className=" bg-[#070707]  p-5 sm:mx-4 rounded-md">
        <h2 className="text-lg font-semibold text-white">Recent Orders</h2>
        <div className="pt-4">
          <div className="relative overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
              <thead className="text-xs text-white uppercase  bg-[#070707] ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Order Id
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Price
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Payment status
                  </th>
                  {/* <th scope="col" className="px-6 py-3">
                    Order status
                  </th> */}
                  <th scope="col" className="px-6 py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.map((o, i) => (
                  <tr key={i} className="text-muted-foreground bg-[#070707] ">
                    <td
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {o._id}
                    </td>
                    <td
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {o.payment_method === 'manual_bank_transfer' ? money(Math.round((o.price + (o.shipping_fee || 0)) * 100)) : formatCurrency(o.price, currencyCode, o.products && o.products[0] && o.products[0].currency ? o.products[0].currency : 'USD')}
                    </td>
                    <td
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {paymentLabel(o.payment_status)}{o.payment_method === "manual_bank_transfer" && <span className="block text-xs">Bank transfer to merchant</span>}
                    </td>
                    {/* <td
                      scope="row"
                      className="px-6 py-4 font-medium whitespace-nowrap"
                    >
                      {o.delivery_status}
                    </td> */}
                    <td scope="row" className="px-6 py-4">
                      <Link to={`/dashboard/order/details/${o._id}`}>
                        <span className="bg-white text-black text-xs whitespace-nowrap font-bold mr-2 px-4 py-1 rounded">
                          View
                        </span>
                      </Link>
                      {(o.payment_method === "manual_bank_transfer" || o.payment_status !== "paid") && (
                        <span
                          onClick={() => redirect(o)}
                          className="whitespace-nowrap cursor-pointer bg-white text-black text-xs font-bold mr-2 px-4 py-1 rounded"
                        >
                          View payment
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
